// PKGV.A3 (#794) — standalone entity-type/edge-type checkbox-group filter
// rail. L1 (locked): B2's own filter control (#1885, unmerged as of this
// story) isn't reusable yet — this is A3's own, with a follow-up filed to
// unify the two once B2 lands. Dynamic per L4: shows every type actually
// present in the loaded subgraph (all 10 possible, not the issue's
// hardcoded 6), each with a live count.

import type { PKGNodeEntityType, PKGEdgeType } from '@blueprint/shared';
import { entityTypeDisplayName, edgeTypeDisplayName } from './pkgFilter.ts';

export interface PKGTypeEdgeFilterControlProps {
  typeCounts: Map<PKGNodeEntityType, number>;
  edgeTypeCounts: Map<PKGEdgeType, number>;
  visibleTypes: Set<PKGNodeEntityType>;
  visibleEdgeTypes: Set<PKGEdgeType>;
  onToggleType: (type: PKGNodeEntityType) => void;
  onToggleEdgeType: (type: PKGEdgeType) => void;
  onReset: () => void;
}

const railStyle: React.CSSProperties = {
  display: 'flex', flexDirection: 'column', gap: 12,
  width: 180, flexShrink: 0, fontSize: 12,
};
const groupLabelStyle: React.CSSProperties = {
  fontSize: 11, fontWeight: 600, color: 'var(--text-secondary)',
  textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4,
};
const rowStyle: React.CSSProperties = {
  display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer',
};

export function PKGTypeEdgeFilterControl({
  typeCounts,
  edgeTypeCounts,
  visibleTypes,
  visibleEdgeTypes,
  onToggleType,
  onToggleEdgeType,
  onReset,
}: PKGTypeEdgeFilterControlProps) {
  const types = Array.from(typeCounts.keys()).sort();
  const edgeTypes = Array.from(edgeTypeCounts.keys()).sort();

  return (
    <div style={railStyle} data-testid="pkg-filter-rail">
      <div>
        <p style={groupLabelStyle}>Entity type</p>
        {types.map(type => (
          <label key={type} style={rowStyle}>
            <input
              type="checkbox"
              checked={visibleTypes.has(type)}
              onChange={() => onToggleType(type)}
              aria-label={`Filter by ${entityTypeDisplayName(type)}`}
            />
            <span>{entityTypeDisplayName(type)}</span>
            <span style={{ color: 'var(--text-secondary)' }}>({typeCounts.get(type)})</span>
          </label>
        ))}
      </div>

      <div>
        <p style={groupLabelStyle}>Edge type</p>
        {edgeTypes.map(type => (
          <label key={type} style={rowStyle}>
            <input
              type="checkbox"
              checked={visibleEdgeTypes.has(type)}
              onChange={() => onToggleEdgeType(type)}
              aria-label={`Filter by ${edgeTypeDisplayName(type)}`}
            />
            <span>{edgeTypeDisplayName(type)}</span>
            <span style={{ color: 'var(--text-secondary)' }}>({edgeTypeCounts.get(type)})</span>
          </label>
        ))}
      </div>

      <button
        type="button"
        onClick={onReset}
        style={{ fontSize: 12, color: 'var(--primary)', background: 'transparent', border: 'none', cursor: 'pointer', padding: 0, textAlign: 'left' }}
      >
        Reset filters
      </button>
    </div>
  );
}
